<template>
  <section class="section subtle" id="contact" style="padding-top: 60px">
    <div class="wrap">
      <div class="section-head" style="margin-bottom: 32px">
        <div>
          <div class="eyebrow-line">Contacto</div>
          <h2 style="font-size: clamp(36px, 5vw, 64px)">¿DUDAS? ESCRÍBENOS.</h2>
        </div>
        <p style="max-width: 420px; color: var(--fg-2); font-size: 17px; margin: 0; line-height: 1.55">
          Resolvemos cualquier duda sobre inscripciones, parejas o el formato de carrera.
          Te respondemos lo antes posible.
        </p>
      </div>

      <div class="contact-grid">
        <a class="contact-card" href="mailto:contacto@elitechip.net">
          <Mail class="contact-icon" :size="30" />
          <div class="contact-label">Correo</div>
          <div class="contact-value">contacto@elitechip.net</div>
          <div class="contact-action">Enviar correo →</div>
        </a>
        <a class="contact-card" href="https://wa.me/34676035552" target="_blank" rel="noopener">
          <MessageCircle class="contact-icon" :size="30" />
          <div class="contact-label">WhatsApp</div>
          <div class="contact-value">+34 676 03 55 52</div>
          <div class="contact-action">Abrir WhatsApp →</div>
        </a>
      </div>

      <div class="contact-orgs">
        <div class="contact-orgs-row">
          <img class="contact-org-logo" src="/assets/logos/org-lockup-gray.svg" alt="Gimnàs Ca Nostra" />
          <img class="contact-org-logo" src="/assets/logos/org-logobw-gray.svg" alt="Elitechip · Cronometratge esportiu" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Mail, MessageCircle } from 'lucide-vue-next'
</script>
